module.exports = __webpack_public_path__ + "img/ck3-castle-hill.8d7b16d5.webp";